import { z } from "zod";

export const UnlockAdvancedStatisticsSchema = z.object({
  events: z.array(
    z.object({
      eventId: z.string(),
      name: z.string(),
      advancedStatistics: z.boolean(),
    })
  ),
});
export type UnlockAdvancedStatisticsForm = z.infer<
  typeof UnlockAdvancedStatisticsSchema
>;

export const getUpdateEventItemsDefaultValues = (
  events: Array<{ id: string; name: string }>
) =>
  events.map((e) => ({
    eventId: e.id,
    name: e.name,
    advancedStatistics: false,
  }));
